import { ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EVENT_KINDS, EVENT_LABELS } from '@tymely/features/Ticket/constants';

import CommentIdWithTooltip from './CommentIdWithTooltip';
import { EventHeaderContainer, EventLabelTypography, EventTextTypography, ExpandIconBox } from '../../styled';
import { FollowUpHeaderProps } from '../types';

const FollowUpHeader = ({ eventData, expanded, onToggle }: FollowUpHeaderProps) => {
    const decision = eventData.decision;
    const { title, comment_id } = decision || {};

    return (
        <ButtonBase
            onClick={onToggle}
            disableRipple
            sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
        >
            <EventHeaderContainer>
                <EventLabelTypography variant="subtitle2" fontWeight="bold">
                    {EVENT_LABELS[EVENT_KINDS.FOLLOW_UP]}:
                </EventLabelTypography>

                {title && (
                    <EventTextTypography variant="body2" sx={{ maxWidth: 450 }}>
                        <b>{title}</b>
                    </EventTextTypography>
                )}

                {comment_id && <CommentIdWithTooltip commentId={comment_id} />}
                <ExpandIconBox>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ExpandIconBox>
            </EventHeaderContainer>
        </ButtonBase>
    );
};

export default FollowUpHeader;
